import React from 'react';

export type JSONViewerType = {
  data: string;
};

const JSONViewer = (properties: JSONViewerType) => {
  const { data } = properties;
  let displayData = '';
  try {
    displayData = JSON.stringify(JSON.parse(data), null, 2);
  } catch (error) {
    displayData = data;
  }
  return (
    <div>
      <pre>{displayData}</pre>
    </div>
  );
};

export default JSONViewer;
